import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ROUTES } from '@app/constants'
import { EMBED_STORAGE_KEYS, registerEmbedBridge } from '@app/helpers/embedBridge'

export const EMBED_PARTNER_PARAM = 'partnerToken'

export const exchangePartnerToken = async (token: string): Promise<boolean> => {
  void token
  return false
}

export const useEmbedBridge = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const cleanup = registerEmbedBridge({
      onGuest: () => {
        navigate(ROUTES.login.short)
      },
      onAuthenticated: async (token) => {
        const exchanged = await exchangePartnerToken(token)
        if (exchanged) {
          navigate(ROUTES.feed.short)
          return
        }
        navigate(ROUTES.login.short)
      },
    })

    return cleanup
  }, [navigate])
}

export const getStoredPartnerToken = () => {
  return localStorage.getItem(EMBED_STORAGE_KEYS.token)
}
